@if (showManualInput) {
<!-- Manual Input Screen -->
<div class="flex-grow bg-white">
  <div class="mb-6">
    <h2 class="text-xl font-bold text-gray-900 mb-1 fs-condensed">
      INGRESA EL VIN MANUALMENTE
    </h2>
    <p class="text-gray-600 fs-condensed">
      ESCRIBE EL VIN DE 17 CARACTERES DE TU VEHÍCULO
    </p>
  </div>

  <!-- Error Message -->
  @if (errorMessage) {
  <div
    class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2"
  >
    <lucide-icon
      [name]="alertCircleIcon"
      [size]="20"
      class="text-red-600"
    ></lucide-icon>
    <span class="text-red-800 text-sm">{{ errorMessage }}</span>
  </div>
  }

  <!-- Success Message -->
  @if (successMessage) {
  <div
    class="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center space-x-2"
  >
    <lucide-icon
      [name]="checkCircleIcon"
      [size]="20"
      class="text-green-600"
    ></lucide-icon>
    <span class="text-green-800 text-sm">{{ successMessage }}</span>
  </div>
  }

  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        VIN del vehículo
      </label>
      <input
        type="text"
        [(ngModel)]="vin"
        (input)="onVinInput($event)"
        (keydown.enter)="handleManualSearch()"
        placeholder="Ingresa el VIN de 17 caracteres"
        class="w-full px-4 py-3 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-center text-lg fs-condensed"
        maxlength="17"
      />
      <div class="mt-2 text-xs text-gray-500 text-center underline">
        {{ vin.length }}/17 caracteres
      </div>
    </div>

    <button
      (click)="handleManualSearch()"
      [disabled]="vin.length !== 17 || isSearching"
      class="w-full bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 font-medium disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
    >
      @if (isSearching) {
      <lucide-icon
        [name]="loader2Icon"
        [size]="20"
        class="animate-spin"
      ></lucide-icon>
      <span>BUSCANDO...</span>
      } @else {
      <lucide-icon [name]="searchIcon" [size]="20"></lucide-icon>
      <span>BUSCAR VEHÍCULO</span>
      }
    </button>

    <!-- Botón de prueba para desarrollo -->
    <!-- <button
      (click)="testVinDecode()"
      class="w-full bg-yellow-600 text-white py-2 px-4 rounded-lg hover:bg-yellow-700 font-medium text-sm"
    >
      Probar con VIN de ejemplo (2HGES16553H585409)
    </button> -->

    <button
      (click)="backToScanner()"
      class="w-full bg-allasRed text-white py-3 px-4 rounded-lg font-medium fs-condensed"
    >
      VOLVER A ESCANEAR
    </button>

    <!-- VIN Guide Toggle -->
    <ng-container *ngTemplateOutlet="vinGuide"></ng-container>
  </div>
</div>
} @else {
<!-- Scanner View -->
<div
  class="relative flex-grow bg-black flex items-center justify-center overflow-hidden h-72"
>
  <!-- Quagga Scanner Container -->
  <div
    #scannerContainer
    id="scanner-container"
    class="w-full h-full relative scanner-container"
  >
    <!-- Fallback video element for camera -->
    <video
      #videoElement
      autoplay
      playsinline
      class="w-full h-full object-cover"
    ></video>
  </div>

  <!-- Scanning overlay -->
  <div
    class="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-40"
  >
    <div
      class="w-11/12 max-w-md h-24 border-2 border-white rounded-lg relative overflow-hidden"
    >
      <div
        class="scan-line absolute top-0 left-0 w-full h-1 bg-red-500 shadow-[0_0_10px_red] animate-pulse"
      ></div>
      <!-- Corner indicators -->
      <div
        class="absolute top-0 left-0 w-6 h-6 border-l-2 border-t-2 border-white"
      ></div>
      <div
        class="absolute top-0 right-0 w-6 h-6 border-r-2 border-t-2 border-white"
      ></div>
      <div
        class="absolute bottom-0 left-0 w-6 h-6 border-l-2 border-b-2 border-white"
      ></div>
      <div
        class="absolute bottom-0 right-0 w-6 h-6 border-r-2 border-b-2 border-white"
      ></div>
    </div>
    <p class="text-white mt-4 text-sm text-center px-4">
      Coloca el código VIN dentro del cuadro para escanearlo
    </p>

    <!-- Scan Attempts Info -->
    @if (scanAttempts > 0) {
    <div class="mt-2 px-4 py-2 bg-yellow-600 bg-opacity-80 rounded-lg">
      <p class="text-white text-xs text-center">
        Intento {{ scanAttempts }}/{{ maxScanAttempts }}
      </p>
    </div>
    }

    <!-- Scanner Status -->
    @if (scannerStatus === 'initializing') {
    <div class="mt-4 px-4 py-2 bg-appPrimary-500 bg-opacity-80 rounded-lg">
      <p class="text-white text-xs text-center">Inicializando escáner...</p>
    </div>
    } @else if (scannerStatus === 'error') {
    <div class="mt-4 px-4 py-2 bg-red-600 bg-opacity-80 rounded-lg">
      <p class="text-white text-xs text-center mb-2">Error en el escáner</p>
      <button
        (click)="restartScanner()"
        class="w-full bg-white bg-opacity-20 text-white px-3 py-1 rounded text-xs hover:bg-opacity-30 transition-colors"
      >
        Reintentar
      </button>
    </div>
    } @else if (scannerStatus === 'scanning') {
    <div class="mt-4 px-4 py-2 bg-green-600 bg-opacity-80 rounded-lg">
      <p class="text-white text-xs text-center">Procesando VIN...</p>
    </div>
    }
  </div>
  <p class="absolute bottom-4 right-4 text-white text-xs opacity-70">
    Powered by QuaggaJS
  </p>
</div>

<!-- Bottom Panel with VIN Guide -->
<div class="bg-white">
  <!-- Error/Success Messages -->
  @if (errorMessage) {
  <div class="p-3 bg-red-50 border-b border-red-200">
    <div class="flex items-center space-x-2">
      <lucide-icon
        [name]="alertCircleIcon"
        [size]="16"
        class="text-red-600"
      ></lucide-icon>
      <span class="text-red-800 text-sm">{{ errorMessage }}</span>
    </div>
  </div>
  } @if (successMessage) {
  <div class="p-3 bg-green-50 border-b border-green-200">
    <div class="flex items-center space-x-2">
      <lucide-icon
        [name]="checkCircleIcon"
        [size]="16"
        class="text-green-600"
      ></lucide-icon>
      <span class="text-green-800 text-sm">{{ successMessage }}</span>
    </div>
  </div>
  }

  <!-- Manual VIN Input Section -->
  <div class="bg-gray-50 p-3 pt-6">
    <h3 class="text-gray-400 mb-3 text-center fs-condensed">
      O ingresa el VIN manualmente
    </h3>

    <div class="space-y-3">
      <div class="flex space-x-2">
        <input
          type="text"
          [(ngModel)]="vin"
          (input)="onVinInput($event)"
          (keydown.enter)="handleManualSearch()"
          placeholder="Ingresa el VIN de 17 caracteres"
          class="flex-1 px-4 py-3 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-center text-xl bg-white fs-condensed"
          maxlength="17"
        />
        <button
          (click)="handleManualSearch()"
          [disabled]="vin.length !== 17 || isSearching"
          class="bg-green-600 text-white p-3 rounded-lg hover:bg-green-700 font-medium disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center"
        >
          @if (isSearching) {
          <lucide-icon
            [name]="loader2Icon"
            [size]="20"
            class="animate-spin"
          ></lucide-icon>
          } @else {
          <lucide-icon [name]="searchIcon" [size]="20"></lucide-icon>
          }
        </button>
      </div>
      <div class="text-xs text-gray-600 text-center opacity-80 underline">
        {{ vin.length }}/17 caracteres
      </div>
    </div>
  </div>

  <!-- VIN Guide Toggle -->
  <ng-container *ngTemplateOutlet="vinGuide"></ng-container>
</div>
}

<ng-template #vinGuide>
  <div class="mt-6">
    <button
      (click)="toggleVinGuide()"
      class="w-full flex items-center justify-center gap-2 p-4 hover:bg-gray-50 transition-colors"
    >
      <span class="font-medium text-gray-900 fs-condensed text-center">
        ¿Dónde encontrar el VIN?
      </span>

      <div
        class="transform transition-transform"
        [class.rotate-180]="showVinGuide"
      >
        <svg
          class="w-5 h-5 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    </button>

    @if (showVinGuide) {
    <div class="bg-gray-50 rounded-sm p-4 mt-2 py-8">
      <h4 class="font-semibold mb-6 fs-condensed text-center">
        Ubicaciones comunes del VIN:
      </h4>

      <div class="flex flex-col gap-8">
        <div class="flex flex-col items-center gap-2">
          <span class="font-medium fs-condensed">Tablero del conductor</span>
          <small class="text-gray-400">
            Visible a través del parabrisas en la esquina inferior izquierda del
            tablero
          </small>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span class="font-medium fs-condensed">
            Marco de la puerta del conductor
          </span>
          <small class="text-gray-400">
            En una etiqueta adherida al marco de la puerta
          </small>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span class="font-medium fs-condensed">
            Compartimento del motor
          </span>
          <small class="text-gray-400">
            En una placa metálica cerca del motor o radiador
          </small>
        </div>
        <div class="flex flex-col items-center gap-2">
          <span class="font-medium fs-condensed">Documentos del vehículo</span>
          <small class="text-gray-400">
            En el título de propiedad, registro o póliza de seguro
          </small>
        </div>
      </div>
    </div>

    }
  </div>
</ng-template>
